var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSessionResolved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.4,
    r: 28,
    fill: "#377E5B",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.4,
    r: 22,
    fill: "#377E5B",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.4,
    r: 16,
    fill: "#2E7D32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1556 31.5814L35.0211 21.7159C35.2539 21.4831 35.5255 21.3667 35.8359 21.3667C36.1463 21.3667 36.418 21.4831 36.6508 21.7159C36.8836 21.9487 37 22.2252 37 22.5453C37 22.8654 36.8836 23.1419 36.6508 23.3747L25.9704 34.0842C25.7376 34.317 25.466 34.4334 25.1556 34.4334C24.8452 34.4334 24.5736 34.317 24.3407 34.0842L19.3353 29.0787C19.1024 28.8458 18.9909 28.5694 19.0006 28.2493C19.0103 27.9291 19.1315 27.6527 19.3644 27.4199C19.5972 27.187 19.8736 27.0706 20.1938 27.0706C20.5139 27.0706 20.7903 27.187 21.0232 27.4199L25.1556 31.5814Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSessionResolved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/session-resolved.5654def184d50fd4be959a6539925cc3.svg";